export default "__VITE_ASSET__oeqWsI1A__"